import React from "react"
import { Text, type TextProps } from "@chakra-ui/layout"

export default function Paragraph({ children, ...rest }: TextProps) {
    return (
        <Text fontSize="md" fontWeight="normal" color="navy.700" {...rest}>
            {children}
        </Text>
    )
}
